<template>
	<div>
		<base-loader v-if="fetching" loader-message="Loading rounds"></base-loader>
		<template v-if="!fetching">
			<table class="w-full table">
				<thead>
					<tr>
						<th>SCORE</th>
						<th>DATE</th>
						<th>TITLE</th>
						<th>COURSE</th>
						<th>VIEW/EDIT</th>
					</tr>
				</thead>
				<tbody>
					<round-list-item
						:key="`round-item-${i}`"
						v-for="(round, i) in rounds"
						:golf-round="round"
						@round-updated="roundUpdated"
					></round-list-item>
				</tbody>
			</table>
		</template>
	</div>
</template>
<script>
/** @format */

export default {
	name: 'BaseRoundList',
	methods: {
		roundUpdated(round) {
			this.rounds = this.rounds.map(c => {
				if (c.uuid === round.uuid) {
					c = round;
				}
				return c;
			});
		},
		refresh() {
			this.fetching = true;
			this.$store.dispatch('rounds/getAll').then(({data}) => {
				this.rounds = data.data;
				this.fetching = false;
				this.$emit('loaded');
			});
		}
	},
	components: {
		'round-list-item': () => import(/* webpackChunkName: "roundListItem" */ './Round/ListItem')
	},
	mounted() {
		this.refresh();
	},
	data() {
		return {
			rounds: [],
			fetching: true
		};
	}
};
</script>
